import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "../LandingPage.module.css";
import { Typography } from "@mui/material";
import { useBreakpoints } from "../ResponsiveBreapoints";

const Disclaimer = () => {
  const { IsXS } = useBreakpoints();
  // const card = [
  //   {
  //     description:
  //       "The content provided on this website is for informational purposes only and does not constitute financial, legal, or professional advice. JP Capital strives to ensure that all information is accurate and up-to-date; however, we do not guarantee its completeness or reliability. Visitors are encouraged to independently verify any information before making decisions based on the content of this site.",
  //   },
  //   {
  //     title: "No Financial or Investment Advice",
  //     description:
  //       "JP Capital is an investor relations firm, and the information on this website should not be construed as financial, investment, or legal advice. Any decision to invest or engage in financial activities should be made in consultation with a qualified professional or financial advisor. We are not liable for any decisions made based on the information provided here.",
  //   },
  //   {
  //     title: "Third-Party Links",
  //     description:
  //       "This website may contain links to third-party websites for your convenience and reference. JP Capital does not endorse or take responsibility for the content, accuracy, or reliability of any external sites linked here. Visitors should exercise caution and review the terms and privacy policies of third-party websites.",
  //   },
  //   {
  //     title: "Limitation of Liability",
  //     description:
  //       "JP Capital, its affiliates, employees, and partners shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from the use of this website or reliance on its content. This includes, but is not limited to, financial loss, data breaches, or business interruptions.",
  //   },
  //   {
  //     title: "Copyright and Intellectual Property",
  //     description:
  //       "All content on this website, including text, graphics, logos, and images, is the intellectual property of JP Capital and is protected by copyright laws. Unauthorized reproduction, distribution, or use of our content is strictly prohibited without prior written consent.",
  //   },
  //   {
  //     title: "Changes to Disclaimer",
  //     description:
  //       "JP Capital reserves the right to update or modify this disclaimer at any time without prior notice. It is the user’s responsibility to review this page periodically to stay informed of any changes.",
  //   },

  //   {
  //     title: "Contact us",
  //     description: (
  //       <>
  //         For questions or concerns regarding this disclaimer, please contact
  //         us:
  //         <ul>
  //           <li>Email: updates@jpcapital.finance</li>
  //           <li>Address: JP Capital, Sharjah City, Sharjah UAE, 515000</li>
  //         </ul>
  //       </>
  //     ),
  //   },
  // ];
  return (
    <Grid container justifyContent="center">
      <Grid
        size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl:5 }}
        className={styles.contactContainer}
        ml={IsXS ? "" : 3}
      >
        <Grid container rowSpacing={2}>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsTitle}>
              FOR YOUR UNDERSTANDING
            </Typography>
          </Grid>
          <Grid size={12} className={styles.centerItem}>
            <Typography className={styles.aboutUsHeading}>
              Providing the Details You Deserve to Know
            </Typography>
          </Grid>
          <Grid>
            <Grid container rowSpacing={2}>
              {/* <Grid>
                    <Typography className={styles.aboutUsTitle}>
                      {data.title}
                    </Typography>
                  </Grid> */}
              <Grid size={12}>
                <Typography className={styles.aboutUsDescription}>
                  JP Capital company profiles and other investor relations
                  materials, publications or presentations, including web
                  content, are based on data obtained from sources we believe to
                  be reliable but are not guaranteed as to accuracy and are not
                  purported to be complete. As such, the information should not
                  be construed as advice designed to meet the particular
                  investment needs of any investor. Any opinions expressed in JP
                  Capital company profiles, or other investor relations
                  materials and presentations are subject to change. JP Capital
                  and its affiliates may buy and sell shares of securities or
                  options of the issuers mentioned on this website at any time.
                  In the purview of Section 17(b) of the Securities Act of 1933
                  and in the interest of full disclosure, we call the reader's
                  attention to the fact that JP Capital is an investor relations
                  firm hired by certain Companies to increase investor awareness
                  to the small-cap equity community. Stock market investing is
                  inherently risky. JP Capital is not responsible for any gains
                  or losses that result from the opinions expressed on this
                  website, in its company profiles or in other investor
                  relations materials or presentations that it publishes
                  electronically or in print. We strongly encourage all
                  investors to conduct their own research before making any
                  investment decision. For more information on stock market
                  investing, visit the Securities and Exchange Commission
                  ("SEC") at www.sec.gov and/or the Ontario Securities
                  Commission (“OSC”) at www.osc.gov.on.ca. Associates and
                  employees of JP Capital, may, from time to time, trade
                  securities of client companies. JP Capital is not a securities
                  broker-dealer, an investment adviser, or a bank, and,
                  accordingly, this information is not subject to FINRA or SEC
                  rules regarding broker-dealer securities research, nor to the
                  regulations to which investment advisers or banks are subject,
                  including regulations regarding independence of written
                  communications. JP Capital expects to be retained and
                  compensated for up to US$40,000 by a third party. This
                  information does not constitute and should not be construed as
                  an independent analysis of the subject company, or as an offer
                  to buy or sell, or a solicitation of an offer to buy or sell
                  any security. This information is published without regard to
                  the specific needs of any person, and it does not take into
                  account the particular financial situation or needs of any
                  individual. Readers should seek professional financial advice,
                  including tax advice, before taking any investment decision.
                  This material is based on information that we believe to be
                  reliable, but JP Capital does not make any express or implied
                  representation or warranty as to the completeness, reliability
                  or accuracy of information contained in this material, or of
                  information used. Investor awareness services and programs are
                  designed to help small-cap companies communicate their
                  investment characteristics.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
 
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Disclaimer;
